import request from 'shared/api-request';
import { Slide } from 'marketing-info-tile/marketing-info-tile.types';

export function getSlides() {
  return request<Slide[]>('/api/marketing-slides');
}
